import { apiPath } from '../../utils/api-contants';
import {
  AssetsLengthRequestPayloadTypes,
  AssetsOnboardingDataRequestPayloadTypes,
  AssetsRequestPayloadTypes,
  BackendServerLengthRequestPayloadTypes,
  BackendServerRequestPayloadTypes,
  GatewaysLatestRequestPayloadTypes,
  GatewaysLengthRequestPayloadTypes,
  InfluxLengthRequestPayloadTypes,
  InfluxRequestPayloadTypes,
  MQBrokerLengthRequestPayloadTypes,
  MQBrokerRequestPayloadTypes,
  NotificationsRequestPayloadTypes,
  TelemtryIngestionDataRequestPayloadTypes,
  UIServerLengthRequestPayloadTypes,
  UIServerRequestPayloadTypes,
} from '../models/connectivity-dashboard';
import axiosClient from './axiosClient';

const connectivityDashboardService = {
  fetchConDashboard: async (payload: any) => {
    try {
      // ?ontology_filter='+payload.ontology_filter+'&limit='+payload.limit+'&skip='+payload.skip+'&parent_id='+payload.parent_id
      //?parent_id='+payload.parent_id+'ontology_filter='+payload.ontology_filter)
      const apiResponse: any = await axiosClient.get(apiPath.SITE_ONTOLOGY_MASTER_URL + '/assets');
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssets: async (payload: AssetsRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_ASSETS_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetsLength: async (payload: AssetsLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_ASSETS_BASE_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetsLatest: async (payload: AssetsRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_ASSETS_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchGatewaysLength: async (payload: GatewaysLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_GATEWAYS_BASE_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchGatewaysLatest: async (payload: GatewaysLatestRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_GATEWAYS_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchGateways: async (payload: GatewaysLatestRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_GATEWAYS_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchMQBrokerLength: async (payload: MQBrokerLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_EMQX_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
      // return {
      //   status: 'success',
      //   code: 'success',
      //   res:{"emqx_count":1,"connected_emqx_count":1,"disconnected_emqx_count":0}
      // };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchMQBroker: async (payload: MQBrokerRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_EMQX_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchInfluxLength: async (payload: InfluxLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_INFLUX_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };

      // return {
      //     status: 'success',
      //     code: 'success',
      //     res: {"influx_count":1,"connected_influx_count":1,"disconnected_influx_count":0},
      //   };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchInflux: async (payload: InfluxRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_INFLUX_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchUIServerLength: async (payload: UIServerLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_UI_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
      // return {
      //   status: 'success',
      //   code: 'success',
      //   res: {"ui_count":1,"connected_ui_count":1,"disconnected_ui_count":0},
      // };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchUIServer: async (payload: UIServerRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_UI_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchBackendServerLength: async (payload: BackendServerLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_BACKEND_URL}/count`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
      // return {
      //   status: 'success',
      //   code: 'success',
      //   res: {"backend_count":1,"connected_backend_count":1,"disconnected_backend_count":0}
      // };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchBackendServer: async (payload: BackendServerRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(apiPath.THINGS_BACKEND_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchNotificationsLatest: async (payload: NotificationsRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_NOTIFICATIONS_URL}`, {
        params: payload,
      });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchNotifications: async (payload: NotificationsRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_NOTIFICATIONS_URL}`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetsOnboardingData: async (payload: AssetsOnboardingDataRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_ASSETS_BASE_URL}/onboarding`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchTelemetryIngestionData: async (payload: TelemtryIngestionDataRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_INFLUX_URL}/ingestion`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetsHistory: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_ASSETS_BASE_URL}/history/${payload.component_id}`, {
        params: payload,
      });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchEmqxInfluxCount: async (payload: MQBrokerLengthRequestPayloadTypes) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_EMQX_INFLUX_URL}/count`, {
        params: payload,
      });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchAssetProperties: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.THINGS_ASSETS_BASE_URL}/properties`, { params: payload });
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default connectivityDashboardService;
